import { createFileRoute, Outlet } from '@tanstack/react-router';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import { SettingsTabBar } from 'src/components/settings/SettingsTabBar';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Header */}
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          px: 4,
        }}
      >
        <Box sx={{ pt: 2, pb: 1.5 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '1.75rem' }}>
            Settings
          </Typography>
        </Box>

        {/* Flat tab bar */}
        <SettingsTabBar />
      </Box>

      {/* Content Area */}
      <ContentArea>
        <Outlet />
      </ContentArea>
    </Box>
  );
}

// ----------------------------------------------------------------------

const ContentArea = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3, 4),
  overflowY: 'auto',
  minHeight: 0,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));
